import { CommonModule } from '@angular/common';
import { Component, computed, Input, signal } from '@angular/core';
import { formatNumber } from '@gs-2.0/core';

import { TranslateLangPipe } from '../../pipes/translate-lang.pipe';
import { NumberFormatPipe } from '../../pipes/number-format.pipe';

@Component({
  selector: 'app-progressbar',
  standalone: true,
  imports: [CommonModule, TranslateLangPipe, NumberFormatPipe],
  templateUrl: './progressbar.component.html',
  styleUrls: ['./progressbar.component.scss'],
})
export class ProgressbarComponent {
  @Input() set current(value: number) {
    this.currentValue.set(value);
  }

  @Input() set total(value: number) {
    this.totalValue.set(value);
  }

  @Input() set daysLeft(value: number) {
    this.daysRemaining.set(value);
  }

  @Input() currency = '$';

  currentValue = signal<number>(0);
  totalValue = signal<number>(0);
  daysRemaining = signal<number>(0);

  percentage = computed(() => {
    const total = this.totalValue();
    const current = this.currentValue();
    if (total === 0) return 0;
    return Math.min(Math.round((current / total) * 100), 100);
  });

  formattedCurrent = computed(() => {
    return formatNumber(this.currentValue());
  });

  formattedTotal = computed(() => {
    return formatNumber(this.totalValue());
  });
}
